module.exports = __webpack_public_path__ + "img/hys-1.c271f7e9.jpg";